class PlayersStore {

  constructor() {
    this.state = {
      players: this.getLocalStorage()
    }
    this.$colors = [
      '#00BCD4', '#F50057', '#4CAF50',
      '#7E57C2', '#CDDC39', '#8BC34A',
      '#009688', '#FF5722', '#607D8B',
    ]
  }

  addPlayer(name) {
    const color = this.$colors[this.state.players.length % this.$colors.length]
    this.state.players.push({
      color,
      name,
      enable : true
    })
  }

  removePlayer(playerIndex) {
    this.state.players.splice(playerIndex, 1)
  }

  getLocalStorage() {
    let storedPlayers = window.localStorage['yaniv-score-users']
    return storedPlayers ? JSON.parse(storedPlayers) : []
  }

  pushLocalStorage() {
    window.localStorage.setItem('yaniv-score-users', JSON.stringify(this.state.players))
  }

}

export default new PlayersStore()



// WEBPACK FOOTER //
// ./src/store/PlayersStore.js